export class AppleDeviceDesiredNameChanged {
  constructor(
    public deviceId: string,
    public newDesiredName: string
  ) {}
}
